import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { AuditFilters } from '@/types/audit';

const ADMIN_ACTIONS = [
  'company.create', 'company.update', 'company.delete', 'company.status_change', 'company.settings_update',
  'user.create', 'user.update', 'user.delete', 'user.invite', 'user.role_change', 'user.status_change',
  'plan.create', 'plan.update', 'plan.delete', 'plan.activate', 'plan.deactivate',
  'system.create', 'system.update', 'system.delete',
  'company_plan.assign', 'company_plan.remove', 'company_plan.upgrade', 'company_plan.downgrade',
  'module.assign', 'module.remove', 'module.seats_change',
];

export const useAdminAuditLogs = (filters?: AuditFilters) => {
  return useQuery({
    queryKey: ['admin-audit-logs', filters],
    queryFn: async () => {
      let query = supabase
        .from('audit_logs')
        .select('*')
        .in('action', ADMIN_ACTIONS)
        .order('created_at', { ascending: false })
        .limit(100);

      if (filters?.startDate) {
        query = query.gte('created_at', filters.startDate);
      }

      if (filters?.endDate) {
        query = query.lte('created_at', filters.endDate);
      }

      if (filters?.actorUserId) {
        query = query.eq('actor_user_id', filters.actorUserId);
      }

      if (filters?.companyId) {
        query = query.eq('company_id', filters.companyId);
      }

      if (filters?.actions && filters.actions.length > 0) {
        query = query.in('action', filters.actions);
      }

      const { data, error } = await query;

      if (error) throw error;
      return data;
    },
  });
};
